module.exports = __webpack_public_path__ + "static/media/as.e0de4550.svg";